import { CliError } from "@/lib/cli/cli-error";
import { LIMITS } from "@/commands/answers/collect-answers-constants";
import type { Answers } from "@/commands/answers/answers";
import { parseAnswerEntry } from "@/commands/answers/parse-answer-entry";
/** `--answers '{}'` used to sail through `JSON.parse` and be posted as
 *  `{"answers": {}}`, contradicting the CLI's own error message. */
export function parseAnswersFlag(raw: string): Answers {
  let decoded: unknown;
  try {
    decoded = JSON.parse(raw);
  } catch {
    throw new CliError("--answers expects a JSON array.", 2);
  }

  if (!Array.isArray(decoded) || decoded.length === 0) {
    throw new CliError(
      '--answers expects a non-empty JSON array, e.g. \'[{"questionId":"q1","selectedOptionIds":["1"]}]\'.',
      2,
    );
  }

  if (decoded.length > LIMITS.ANSWERS) {
    throw new CliError(
      `--answers carries more than ${LIMITS.ANSWERS} entries.`,
      2,
    );
  }

  for (const [index, entry] of decoded.entries()) {
    parseAnswerEntry(entry, `--answers[${index}]`);
  }

  return decoded as Answers;
}
